import axios from "axios";
import { Config } from "../Common/Config";
import { pushTraceLogEvent } from "./sessionEventPush";

export const spacerData = async (apiName, payload, url, traceEventName) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log('spacerData ::::', payload)
      // const response = await axios.get(`${Config.url}${apiName}`,{data : payload}, {
      //     headers: {
      //         'Content-Type': 'application/json',
      //         'Authorization': `Bearer ${localStorage.getItem('token')}`
      //     }
      // });
      const response = await axios.get(`${url || Config.url}${apiName}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: payload, // ← Use this instead of `data` for GET
      });

      const isBusinessFailure = response?.data?.success === false;
      if (isBusinessFailure && apiName!="conflict-alerts" && apiName!="csr-rooms") {
        pushTraceLogEvent({
          event: "api_failed",
          step_status: "failed",
          payload: {
            api: apiName,
            request: payload,
            message: response.data.message,
            error: response.data.error,
          },
        });
      } else if (traceEventName && !isBusinessFailure) {
        pushTraceLogEvent({
          event: traceEventName,
          step_status: "success",
          payload: { api: apiName, request: payload },
          response: response?.data,
        });
      }

      resolve(response);
    } catch (error) {
      if(apiName!="conflict-alerts" && apiName!="csr-rooms"){
      pushTraceLogEvent({
        event: "api_failed",
        step_status: "failed",
        payload: {
          api: apiName,
          request: payload,
          message: error?.message || error,
          error: error,
        },
      });
      console.log("error in get clinic data ::::", error);
      resolve(error);
      }
    }
  });
};

export const genericApiCall = async (apiName, payload, url, traceEventName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${url || Config.url}${apiName}`,
        {
          ...payload,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const res = await response.data;
      const isBusinessFailure = res?.success === false;
      if (isBusinessFailure) {
        pushTraceLogEvent({
          event: "api_failed",
          step_status: "failed",
          payload: {
            api: apiName,
            request: payload,
            message: response.data.message,
            error: response?.data?.error,
          },
        });
      } else if (traceEventName) {
        pushTraceLogEvent({
          event: traceEventName,
          step_status: "success",
          payload: { api: apiName, request: payload },
          response: res,
        });
      }
      if (res?.success) {
        resolve(response);
      } else if (!res?.success) {
        resolve(response);
        return;
      }
      if (response) {
        // getAlllunchAndSpacerData(1)
        resolve(response);
      }
    } catch (error) {
      pushTraceLogEvent({
        event: "api_failed",
        step_status: "failed",
        payload: {
          api: apiName,
          request: payload,
          message: error?.message || error,
          error: error?.data?.error,
        },
      });
      resolve([]);
    }
  });
};
